import { render, staticRenderFns } from "./RandomCallIndex.vue?vue&type=template&id=431ce9a2&"
import script from "./RandomCallIndex.vue?vue&type=script&lang=js&"
export * from "./RandomCallIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports